import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import type { VFC } from 'react';

import LinkButton from '@/components/CustomButton/LinkButton';
import {
  SHOW_SERVICE_TERMINATION_NOTICE,
  SERVICE_TERMINATION_DETAILS_URL,
} from '@/config/closure';
import routes from '@/config/routes';

import styles from './HeroSection.module.scss';

//{/*routes.marketplace*/}
const HeroSection: VFC = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const locale = router.locale;

  return (
    <section className={styles.hero}>
      <h2 className="container">
        {SHOW_SERVICE_TERMINATION_NOTICE && (
          <div className={styles.terminationNotice}>
            {locale === 'ja' ? (
              <p>
                サービス終了のお知らせ。
                <a
                  href={SERVICE_TERMINATION_DETAILS_URL.JA}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  詳細はこちら
                </a>
              </p>
            ) : (
              <p>
                Notice of service termination.
                <a
                  href={SERVICE_TERMINATION_DETAILS_URL.EN}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  More details
                </a>
              </p>
            )}
          </div>
        )}
        <span>Japanese Pop Culture Empowered</span>
        <span className={styles.byBlockchain}>By Blockchain</span>
        <LinkButton
          className={styles.MarketplaceButton}
          href={
            locale === 'en'
              ? routes.marketplace
              : `/${locale}${routes.marketplace}`
          }
        >
          {t('header.marketplace')}
        </LinkButton>
      </h2>
    </section>
  );
};

export default HeroSection;
